export const API_KEY = process.env.REACT_APP_SHEETS_API_KEY;
export const SPREADSHEET_ID = process.env.REACT_APP_SHEETS_SPREADSHEET_ID;
export const URL_PREFIX = 'https://sheets.googleapis.com/v4/spreadsheets/';
export const URL_EDIT_PREFIX = 'https://content-sheets.googleapis.com/v4/spreadsheets/';
export const EVERYONE_OPTION = '###Everyone###';